<template>
  <div class="col-md-12 text-center" style="margin-top: 1em">
    <div>
      <h6>
        <i class="fa fa-check-circle" style="font-size: 2em; color: #2ca8ff"></i>
        <p style="margin-top: 1em" v-if="ahcRequest.latestStatus == 'Assigned'">
          {{ $t("message.Appointment has been booked") }}
        </p>
        <p style="margin-top: 1em" v-if="ahcRequest.latestStatus == 'reportUpdated'">
          {{ $t("message.Reports have been updated") }}
        </p>
      </h6>

      <div class="col-12 text-left" style="margin-top: 2em">
        <span style="font-weight: 600">{{ $t("message.Booking Details") }}</span>
        <div class="col-12">
          <span style="font-weight: 600">
            {{ $t("message.Booking ID") }}:
            <span style="font-weight: 500">{{
              ahcRequest.labBookingReference
            }}</span>
          </span>
          <br />
          <span style="font-weight: 600">
            {{ $t("message.Health Package") }}:
            <span style="font-weight: 500">{{
              ahcRequest.healthPackage.name
            }}</span>
          </span>
        </div>
      </div>

      <div class="col-12 text-left" style="margin-top: 2em">
        <span style="font-weight: 600">{{ $t("message.Lab Details") }}</span>
        <div class="col-12">
          <span style="font-size: 1.2em; font-weight: 500">{{
            ahcRequest.selectedLab.name
          }}</span>,
          <br />
          <a style="font-size: 1.2em" :href="'tel:' + ahcRequest.selectedLab.contact" target="_blank">{{ ahcRequest.selectedLab.contact }}</a>
          <br />
          <span style="font-size: 0.9em" v-if="ahcRequest.latestStatus == 'Assigned'">
            <br />
            {{ ahcRequest.selectedLab.address }}
          </span>
        </div>
      </div>

      <div class="col-12 text-left" style="margin-top: 2em">
        <span style="font-weight: 600">{{ $t("message.Date & Time") }}</span>
        <div class="col-12">
          {{ getFormattedDate(ahcRequest.scheduledTimestamp.start) }}
          &nbsp;&nbsp;
          {{ getFormattedTime(ahcRequest.scheduledTimestamp.start) }} : 00
        </div>
      </div>

      <div class="col-12 text-left" style="margin-top: 2em" v-if="ahcRequest.latestStatus == 'Assigned'">
        <span style="font-weight: 600">{{ $t("message.Location") }}</span>
        <div>
          <iframe width="100%" height="200" src="https://maps.google.com/maps?width=100%&amp;height=200&amp;hl=en&amp;q=WJ4X%2BVM%20HSR%20Layout%2C%20Bengaluru%2C%20Karnataka+(Lab)&amp;ie=UTF8&amp;t=&amp;z=17&amp;iwloc=B&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
        </div>
      </div>

      <div class="col-12 text-left" style="margin-top: 2em" v-if="ahcRequest.latestStatus == 'reportUpdated'">
        <span style="font-weight: 600">{{ $t("message.Reports") }}</span>
        <div class="col-12" v-for="file in ahcRequest.files" :key="file.fileId">
          <card @click.native="viewPdf(file)">
            <div class="row">
              <div class="col-2">
                <i class="now-ui-icons files_paper"></i>
              </div>
              <div style="line-height: 18px">{{ file.name }}</div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ahc-report",

  computed: {
    ahcRequest() {
      return this.$store.state.selectedAhcAppointment;
    },
  },

  methods: {
    getFormattedDate(date) {
      return moment(parseInt(date)).format("MMMM Do YYYY");
    },
    getFormattedTime(date) {
      return new Date(parseInt(date)).getHours();
    },
    async viewPdf(file) {
      let url = (await this.$store.dispatch("getFile", file.fileId)).data;
      PhotoViewer.show(url, file.name);
    },
  },
};
</script>
